import * as React from 'react';
import {Dispatch} from "react";

type companyFormDataProps = {
    translations: any,
    companyNameError: boolean,
    companyName: string,
    companyCodeError: boolean,
    companyCode: string,
    responsiblePersonError: boolean,
    responsiblePerson: string,
    emailError: boolean,
    email: string,
    phoneNumberError: boolean,
    phoneNumber: string,
    message: string,
    setCompanyName: Dispatch<any>,
    setCompanyCode: Dispatch<any>,
    setResponsiblePerson: Dispatch<any>,
    setEmail: Dispatch<any>,
    setPhoneNumber: Dispatch<any>,
    setMessage: Dispatch<any>
};

export const CompanyFormData = ({
                                    translations,
                                    companyNameError,
                                    companyName,
                                    companyCodeError,
                                    companyCode,
                                    responsiblePersonError,
                                    responsiblePerson,
                                    emailError,
                                    email,
                                    phoneNumberError,
                                    phoneNumber,
                                    message,
                                    setCompanyName,
                                    setCompanyCode,
                                    setResponsiblePerson,
                                    setEmail,
                                    setPhoneNumber,
                                    setMessage
                                }: companyFormDataProps) => {
    return (
        <>
            <div className="col-md-12">
                <input
                    style={companyNameError ? {borderColor: 'red'} : {}}
                    id="company-name"
                    value={companyName}
                    onChange={e => setCompanyName(e.target.value)}
                    className="form-control"
                    placeholder={translations.company_name}
                />
            </div>
            <div className="col-md-6">
                <input
                    style={companyCodeError ? {borderColor: 'red'} : {}}
                    id="company-code"
                    value={companyCode}
                    onChange={e => setCompanyCode(e.target.value)}
                    className="form-control"
                    placeholder={translations.company_code}
                />
            </div>
            <div className="col-md-6">
                <input
                    style={responsiblePersonError ? {borderColor: 'red'} : {}}
                    id="responsible-person"
                    value={responsiblePerson}
                    onChange={e => setResponsiblePerson(e.target.value)}
                    className="form-control"
                    placeholder={translations.responsible_person}
                />
            </div>
            <div className="col-md-6">
                <input
                    style={emailError ? {borderColor: 'red'} : {}}
                    id="email-address"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="form-control"
                    placeholder={translations.email}
                />
            </div>
            <div className="col-md-6">
                <input
                    style={phoneNumberError ? {borderColor: 'red'} : {}}
                    id="phone-number"
                    value={phoneNumber}
                    onChange={e => setPhoneNumber(e.target.value)}
                    className="form-control"
                    placeholder={translations.phone_number}
                    onFocus={e => e.target.placeholder = '+370'}
                    onBlur={e => e.target.placeholder = translations.phone_number}
                />
            </div>
            <div className="col-md-12">
                    <textarea id="individual-message" className="form-control" value={message}
                              onChange={e => setMessage(e.target.value)}
                              placeholder={translations.individual_message}/>
            </div>
        </>
    );
}
